import { isTest } from '#common/util';
import { MINIO_PROVIDER } from '#object-store/types';
export const isKnownReliableProvider = (provider) => {
    if (['aws', 'ibm', 'azure', 'gcp', 'wasabi'].includes(provider.toLowerCase())) {
        return true;
    }
    if (isTest()) {
        return [MINIO_PROVIDER].includes(provider.toLowerCase());
    }
    return false;
};
